import { Token } from '@pulsex/sdk'
import { BIG_ZERO } from '@pulsex/utils/bigNumber'
import { Text, useMatchBreakpoints } from '@pulsex/uikit'
import BigNumber from 'bignumber.js'
import { DeserializedPool } from '@pulsex/pools'
import { useTranslation } from '@pulsex/localization'
import BaseCell, { CellContent } from './BaseCell'
import Apr from '../Apr'

interface AprCellProps {
  pool: DeserializedPool<Token>
}

const AprCell: React.FC<AprCellProps> = ({ pool }) => {
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()
  const { userData } = pool
  const stakedBalance = userData?.stakedBalance ? new BigNumber(userData.stakedBalance) : BIG_ZERO

  return (
    <BaseCell role="cell" flex={['1 0 50px', '1 0 50px', '2 0 100px', '2 0 100px', '1 0 120px']}>
      <CellContent>
        <Text fontSize="12px" color="textSubtle" textAlign="left">
          {t('APR')}
        </Text>
        <Apr pool={pool} stakedBalance={stakedBalance} showIcon={!isMobile} />
      </CellContent>
    </BaseCell>
  )
}

export default AprCell
